export var VALID_DOMAIN_REGEX = /^(?:http[s]?:\/\/)?(?:localhost|(?:(?:[a-z](?:(?:[a-z0-9]*?[-_]?[a-z0-9]*)?[a-z0-9]){0,4})\.){1,4}[a-z]{2,24})$/i;
export var VALID_URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i;
export var DEFAULT_NOTIFICATION_ACTION_OPEN_URL_LABEL = 'Visit Site';
export var DEFAULT_NOTIFICATION_ACTION_CLOSE_LABEL = 'Dismiss';
export var DATE_ONLY_FORMAT = 'LL';
export var DATE_ONLY_SHORT_FORMAT = 'll';
export var TIME_ONLY_FORMAT_WITH_TZ = 'LT z';
export var TIME_ONLY_FORMAT_WITHOUT_TZ = 'LT';
export var DATE_TIME_FORMAT_WITH_TZ = 'll LT z';
export var DATE_TIME_FORMAT_WITHOUT_TZ = 'll LT';
export var DEFAULT_DRAWER_FORM_ITEM_LAYOUT = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 6
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 18
    }
  }
};

// Feature Flags
export var FEAT_CHANNEL_WEB = 'FEAT_CHANNEL_WEB';
export var FEAT_CHANNEL_ANDROID = 'FEAT_CHANNEL_ANDROID';
export var FEAT_CHANNEL_IOS = 'FEAT_CHANNEL_IOS';